import React from "react";
import FormMap from "./FormMap";
import Info from "./Info";
import "./form.css";

const FormHome = () => {
  return (
    <div className="formHome">
      <FormMap />
      <Info />
    </div>
  );
};

export default FormHome;
